const actionMiniGame = {
    CLOSE_GAME: 1, //đóng game
    OPEN_TRANSFER: 2, // mở popup chuyển quỹ khi user cược ko đủ số dư
    LOAD_BALANCE: 3, // reload số dư khi chuyển quỹ thành công hoặc hoặc ngược lại
    LOGOUT: 4, //user logout ở trang chủ
};

export default actionMiniGame;
